import Polyglot from 'node-polyglot';
import { isEmpty, join, map, pipe, reject, slice, split, takeLast, toUpper } from 'ramda';

import STRINGS from './resources';
import { strings } from './shared-strings';
import { features } from './features';
import { polyglotRegistry } from './polyglot-registry';

const polyglot = new Polyglot({
  locale: polyglotRegistry.getLocale(),
  phrases: { ...STRINGS }
});

polyglotRegistry.register(polyglot, {
  en: STRINGS,
  loaders: {
    es: () => import(/* webpackChunkName: "common-utils-locale-es" */ './locales/es'),
    fil: () => import(/* webpackChunkName: "common-utils-locale-fil" */ './locales/fil'),
    ja: () => import(/* webpackChunkName: "common-utils-locale-ja" */ './locales/ja'),
    th: () => import(/* webpackChunkName: "common-utils-locale-th" */ './locales/th')
  }
});

export const snakeToHumanCase = str =>
  str &&
  pipe(
    split('.'),
    takeLast(1),
    join(' '),
    split('_'),
    reject(isEmpty),
    map(word => toUpper(word[0]) + slice(1, Infinity, word)),
    join(' ')
  )(str);

const t = (key, params, defaultValue) =>
  polyglot.t(key, {
    ...params,
    _: defaultValue || snakeToHumanCase(key)
  });
export default t;

// capitalize only the first letter of the string.
export const capitalizeFirstLetter = string => string.charAt(0).toUpperCase() + string.slice(1);

export const fileUploadTranslate = (key, params, defaultValue) => t(`file_upload.${key}`, params, defaultValue);
export const backgroundOperTranslate = (key, params, defaultValue) =>
  t(`backgroundOperations.${key}`, params, defaultValue);

export const sharedStrings = strings;
export const sharedFeatures = features;
